export default __webpack_public_path__ + "static/media/factory_green.02d3238b.svg";